import "@components/MessagesFab.module.css";

import { useQuery } from "@apollo/client";
import { IonFabButton } from "@ionic/react";
import { useMemo } from "react";
import { useIntl } from "react-intl";
import { useLocation } from "react-router";

import Icon from "@components/text/Icon";
import useGlobalOpener from "@hooks/useGlobalOpener";
import { OpenerTypeEnum } from "@typing/Enums";
import {
  GetJourneyForMessagesDocument,
  GetJourneyForMessagesQuery,
  GetJourneyForMessagesQueryVariables
} from "@typing/Generated";

type Props = {
  journeyId: string;
};

const MessagesFab = ({ journeyId }: Props) => {
  const intl = useIntl();
  const location = useLocation();
  const messagesOpener = useGlobalOpener(OpenerTypeEnum.MESSAGES);

  const getJourneyForMessagesQuery = useQuery<GetJourneyForMessagesQuery, GetJourneyForMessagesQueryVariables>(
    GetJourneyForMessagesDocument,
    {
      variables: {
        id: journeyId
      }
    }
  );

  const unreadMessageCountData = useMemo(() => {
    const unreadMessageCount = getJourneyForMessagesQuery.data?.journey.chats.reduce(
      (accumulator, chat) => accumulator + chat.unreadMessageCount,
      0
    );
    if (!unreadMessageCount) return {};

    // eslint-disable-next-line @typescript-eslint/naming-convention
    return { "data-unread": unreadMessageCount };
  }, [getJourneyForMessagesQuery.data?.journey.chats]);

  if (location.pathname.includes("/messages")) {
    return null;
  }

  return (
    <IonFabButton
      {...unreadMessageCountData}
      aria-label={intl.formatMessage({ id: "accessibility.ariaLabels.toggleMessages" })}
      className="ion-hide-lg-down"
      color="secondary-500"
      onClick={messagesOpener.toggle}
      size="small"
    >
      <Icon color="white" icon="messages" />
    </IonFabButton>
  );
};

export default MessagesFab;
